
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBipolar_transistor03Flat as ObiBipolar_transistor03FlatElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-bipolar_transistor-03-flat.js';
 
 
 

 
 export const ObiBipolar_transistor03Flat = createComponent({
   react: React,
   tagName: 'obi-bipolar_transistor-03-flat',
   elementClass: ObiBipolar_transistor03FlatElement,
   events: {
     
   }
  });
 
 